<ion-progress-bar [value]="progress" class="progress-bar" [ngClass]="customClass ? customClass : '' "></ion-progress-bar>
